module.exports = __webpack_public_path__ + "img/archer.7172d852.png";